class BurgerPlugin {
	constructor(element, target, options) {
		this.options = options || {};
		this.burgerEl = element;
		this.targetEl = target;
		this.overlayEl = document.getElementById("overlay");
		this.htmlEl = document.getElementById("html");
		this.isOpen = false;

		// Додавання обробників подій
		this.burgerEl.addEventListener("click", this.toggleSidebar.bind(this));
		this.overlayEl.addEventListener("click", this.toggleSidebar.bind(this));

		document
			.querySelectorAll(".go")
			.forEach((el) =>
				el.addEventListener("click", this.toggleSidebar.bind(this))
			);

		document.addEventListener("keyup", this.onKeyUp.bind(this));
	}

	toggleSidebar(event) {
		event.preventDefault();
		this.htmlEl.classList.toggle("opened-sidebar");
		this.targetEl.classList.toggle("opened");
		this.burgerEl
			.querySelectorAll("svg")
			.forEach((element) => element.classList.toggle("hidden"));
		// Оновлення значень атрибутів ARIA
		if (this.htmlEl.classList.contains("opened-sidebar")) {
			this.isOpen = true;
			this.triggerEvent("burger-opened");
			this.burgerEl.setAttribute("aria-expanded", "true");
			this.targetEl.removeAttribute("aria-hidden");
		} else {
			this.isOpen = false;
			this.triggerEvent("burger-closed");
			this.burgerEl.setAttribute("aria-expanded", "false");
			this.targetEl.setAttribute("aria-hidden", "true");
		}
	}

	onKeyUp(event) {
		if (event.keyCode === 27 && this.isOpen) {
			this.toggleSidebar(event);
		}
	}

	triggerEvent(eventName) {
		const event = new Event(eventName);
		document.dispatchEvent(event);
	}
}
export default BurgerPlugin;
